import  { useState,useEffect } from 'react';
import './User.css'
import Cowboy from '../Images/Cowboy Hat.png';


export default function User({ username }) {
    const [uploadedImage, setUploadedImage] = useState(null);
  
    useEffect(() => {
      const uploadButton = document.getElementById('UploadButton');
      const fileInput = document.getElementById('ImageInput');
  
      const handleButtonClick = () => {
        fileInput.click();
      };
  
      const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        console.log(selectedFile);
      };
  
      uploadButton.addEventListener('click', handleButtonClick);
      fileInput.addEventListener('change', handleFileChange);
  
      return () => {
        uploadButton.removeEventListener('click', handleButtonClick);
        fileInput.removeEventListener('change', handleFileChange);
      };
    }, []);
  

  



  const handleImageUpload = (event) => {
    const selectedFile = event.target.files[0];
    setUploadedImage(selectedFile);
  };

  return (
    <div className="User-Wrapper">
      {username ? (
        <div className="User-Head">
          <span>
            <img id="CowboyHat" src={Cowboy} alt="Loading" /> {username}
          </span>
        </div>
      ) : (
        ""
      )}

      <div className="User-Image-Wrapper">
        {uploadedImage ? (
          <img src={URL.createObjectURL(uploadedImage)} alt="Uploaded" />
        ) : (
          
            <img src={require("../Images/prettypixels.png")} alt='Loading'/>
     
        )}
         <button  id="UploadButton" ></button>
           <input
          id="ImageInput"
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{ display: 'none' }} // Hide the input visually
        />
      </div>
    </div>
  );
}
